import styled from 'styled-components'
import { layout, typography, space, flexbox, color, border } from 'styled-system'
import { LazyLoadImage } from 'react-lazy-load-image-component'

import { A } from 'components/generic/HomePageComponents'

export const HeroBannerContainer = styled.div`
  margin-right: auto;
  margin-left: auto;
  padding-left: 16px;
  padding-right: 16px;
  display: flex;
  justify-content: center;
  overflow-x: hidden;
  flex-direction: row;
  align-items: center;
  background-color: ${(props) => props.theme.colors.secondary};
  ${layout}
  ${space}
`

export const HeroBannerAligner = styled.div`
  max-width: 1170px;
  width: 100%;
`

export const HeroBannerTitle = styled.h1`
  color: ${(props) => props.theme.colors.white};
  font-size: 32px;
  font-weight: bold;
  margin: 22px 0px;
  ${flexbox}
`

export const HeroBannerText = styled.p`
  display: block;
  color: ${(props) => props.theme.colors.white};
  font-size: 16px;
  font-weight: bold;
  padding: 8px 0px 0px;
  margin-top: 0px;
  align-self: flex-start;
  ${flexbox}
`

export const CTAButton = styled(A)`
  transition: background-color 0.5s ease;
  font-weight: bold;
  white-space: normal;
  text-decoration: none;
  border-radius: 5px;
  text-align: center;
  background-color: ${(props) => props.theme.colors.white};
  color: ${(props) => props.theme.colors.textColor};
  box-shadow: 0 1px 5px rgba(0,0,0,0.4);
  padding: 8px 32px 8px;
  border: 2px solid;
  border-color: ${(props) => props.theme.colors.white};
  margin-bottom: 32px;
  align-self: flex-start;
  max-height: 42px;
  max-width: 256px;
  :hover {
    background-color: ${(props) => props.theme.colors.secondary};
    color: ${(props) => props.theme.colors.white};
    border: 2px solid ${(props) => props.theme.colors.white};
  }
  ${layout}
  ${typography}
  ${space}
  ${flexbox}
`

export const HeroBannerButtonText = styled.p`
  margin: 4px 0px;
`

export const PostProfileCTAContainer = styled.div`
  cursor: pointer;
  border-radius: 5px;
  display: block;
  overflow: hidden;
  margin-bottom: 16px;
  position: relative;
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.4);
  word-break: break-word;
  text-decoration: none;
  background-color: ${(props) => props.theme.colors.secondary};
  color: ${(props) => props.theme.colors.white};
  &:hover {
    box-shadow: 0 3px 8px 0 rgba(0, 0, 0, 0.3);
  }
  ${layout}
  ${space}
`
export const PostProfileCTAText = styled.p`
  display: table-cell;
  color: ${(props) => props.theme.colors.white};
  font-size: 20px;
  font-weight: bold;
  padding: 1rem;
  ${layout}
  ${typography}
  ${space}
  ${flexbox}
  @media (width: 1024px) {
    width: 45%
  }
`

export const CTAButtonContainer = styled.div`
  width: 16rem;
  display: table-cell;
  border-radius: 5px;
  padding: 1rem;
  vertical-align: middle;
  align-self: center;
  margin-left: auto;
  ${layout}
  ${space}
`

export const ImageCTAContainer = styled.div`
  cursor: pointer;
  border-radius: 5px;
  display: block;
  background-color: ${(props) => props.theme.colors.inverseColor};
  position: relative;
  text-decoration: none;
  margin-top: 24px;
  ${border}
  ${layout}
  ${space}
  ${color}
`

export const ImageCTATitle = styled.div`
  color: ${(props) => props.theme.colors.white};
  font-size: 20px;
  font-weight: bold;
  padding-bottom: .5rem;
  ${layout}
  ${space}
`

export const ImageCTABodyText = styled.div`
  color: ${(props) => props.theme.colors.white};
  font-size: 16px;
  ${color}
`

export const KathyCTAButton = styled(CTAButton)`
  :hover {
    color: ${(props) => props.theme.colors.textColor};
    background-color: ${(props) => props.theme.colors.grey};
  }
`

export const CTALazyImage = styled(LazyLoadImage)`
  height: 100px;
  width: 100px;
  margin-right: 0.5rem;
`

export const UpgradeCTAContainer = styled.div`
  cursor: pointer;
  border-radius: 5px;
  display: block;
  overflow: hidden;
  margin-top: 16px;
  margin-bottom: 16px;
  position: relative;
  word-break: break-word;
  text-decoration: none;
  background-color: ${(props) => props.theme.colors.inverseColor};
  color: ${(props) => props.theme.colors.white};
`

const LoadingSkeleton = styled.div`
  display: block;
  margin-bottom: 16px;
  ${(props) => `background: linear-gradient(-90deg, ${props.theme.colors.secondary} 0%, #f5f5f5 50%, ${props.theme.colors.secondary} 100%);`}
  background-size: 400% 400%;
  border-radius: 5px;
  animation: pulse 3s ease-in-out infinite;
  ${layout}
  ${space}
  @keyframes pulse {
    0% {
      background-position: 0% 0%;
    }
    100% {
      background-position: -135% 0%;
    }
  }
`

export const BannerLoadingSkeleton = styled(LoadingSkeleton)`
  &::before {
    content: "\00a0";
  }
`